<script setup lang="ts">
import Button from 'primevue/button'

defineProps<{
    label?: string
    icon?: string
    size?: 'small' | 'large'
    severity?: 'primary' | 'secondary' | 'danger' | 'success'
    text?: boolean
    disabled?: boolean
    loading?: boolean
    type?: 'button' | 'submit' | 'reset'
}>()
</script>

<template>
    <Button
        :label="label"
        :icon="icon"
        :size="size"
        :severity="severity"
        :text="text"
        :disabled="disabled"
        :loading="loading"
        :type="type ?? 'button'"
    >
        <slot />
    </Button>
</template>
